import { defineMessages } from 'react-intl-next';

export default defineMessages({
	white: {
		id: 'fabric.theme.white',
		defaultMessage: 'White',
		description:
			'Tooltip label for the white color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'light-blue': {
		id: 'fabric.theme.light-blue',
		defaultMessage: 'Light blue',
		description:
			'Tooltip label for the light blue color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'light-teal': {
		id: 'fabric.theme.light-teal',
		defaultMessage: 'Light teal',
		description:
			'Tooltip label for the light teal color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'light-green': {
		id: 'fabric.theme.light-green',
		defaultMessage: 'Light green',
		description:
			'Tooltip label for the light green color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'light-yellow': {
		id: 'fabric.theme.light-yellow',
		defaultMessage: 'Light yellow',
		description:
			'Tooltip label for the light yellow color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'light-red': {
		id: 'fabric.theme.light-red',
		defaultMessage: 'Light red',
		description:
			'Tooltip label for the light red color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'light-purple': {
		id: 'fabric.theme.light-purple',
		defaultMessage: 'Light purple',
		description:
			'Tooltip label for the light purple color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'light-gray': {
		id: 'fabric.theme.light-gray',
		defaultMessage: 'Light gray',
		description:
			'Tooltip label for the light gray color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	blue: {
		id: 'fabric.theme.blue',
		defaultMessage: 'Blue',
		description:
			'Tooltip label for the blue color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	teal: {
		id: 'fabric.theme.teal',
		defaultMessage: 'Teal',
		description:
			'Tooltip label for the teal color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	green: {
		id: 'fabric.theme.green',
		defaultMessage: 'Green',
		description:
			'Tooltip label for the green color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	yellow: {
		id: 'fabric.theme.yellow',
		defaultMessage: 'Yellow',
		description:
			'Tooltip label for the yellow color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	red: {
		id: 'fabric.theme.red',
		defaultMessage: 'Red',
		description:
			'Tooltip label for the red color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	orange: {
		id: 'fabric.theme.orange',
		defaultMessage: 'Orange',
		description:
			'Tooltip label for the orange color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	purple: {
		id: 'fabric.theme.purple',
		defaultMessage: 'Purple',
		description:
			'Tooltip label for the purple color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	gray: {
		id: 'fabric.theme.gray',
		defaultMessage: 'Gray',
		description:
			'Tooltip label for the gray color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'dark-blue': {
		id: 'fabric.theme.dark-blue',
		defaultMessage: 'Dark blue',
		description:
			'Tooltip label for the dark blue color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'dark-teal': {
		id: 'fabric.theme.dark-teal',
		defaultMessage: 'Dark teal',
		description:
			'Tooltip label for the dark teal color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'dark-green': {
		id: 'fabric.theme.dark-green',
		defaultMessage: 'Dark green',
		description:
			'Tooltip label for the dark green color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'dark-yellow': {
		id: 'fabric.theme.dark-yellow',
		defaultMessage: 'Dark yellow',
		description:
			'Tooltip label for the dark yellow color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'dark-red': {
		id: 'fabric.theme.dark-red',
		defaultMessage: 'Dark red',
		description:
			'Tooltip label for the dark red color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'dark-purple': {
		id: 'fabric.theme.dark-purple',
		defaultMessage: 'Dark purple',
		description:
			'Tooltip label for the dark purple color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'subtle-gray': {
		id: 'fabric.theme.subtle-gray',
		defaultMessage: 'Subtle gray',
		description:
			'Tooltip label for the subtle gray color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	'bold-gray': {
		id: 'fabric.theme.bold-gray',
		defaultMessage: 'Bold gray',
		description:
			'Tooltip label for the bold gray color swatch displayed in the editor toolbar color palette when users select text or highlight colors.',
	},
	// Colors only used in highlight palette
	'no-color': {
		id: 'fabric.theme.no-color',
		defaultMessage: 'No highlight',
		description:
			'Tooltip for the no color option in the highlight color palette in the main editor toolbar',
	},
	lime: {
		id: 'fabric.theme.lime',
		defaultMessage: 'Lime',
		description: "Tooltip for the lime color used in the main toolbar's highlight color palette",
	},
	magenta: {
		id: 'fabric.theme.magenta',
		defaultMessage: 'Magenta',
		description: "Tooltip for the magenta color used in the main toolbar's highlight color palette",
	},
});
